import { I18nProvider, ThemeEnum, ThemeProvider, useTheme } from '@servicepipe/ui-components';
import React, { useEffect } from 'react';

const DefaultLightTheme = ({ children }) => {
  const { setTheme } = useTheme();

  useEffect(() => {
    setTheme(ThemeEnum.light);
  }, [setTheme]);

  return children;
};

export const AppThemeProvider = ({ children }) => {
  return (
    <ThemeProvider>
      <I18nProvider language="en" locale="en-US">
        <DefaultLightTheme>{children}</DefaultLightTheme>
      </I18nProvider>
    </ThemeProvider>
  );
};
